export const colorMap: Record<string, string> = {
    "red": "bg-red-600",
    "orange": "bg-orange-600",
    "amber": "bg-amber-600",
    "yellow": "bg-yellow-600",
    "lime": "bg-lime-600",
    "green": "bg-green-600",
    "emerald": "bg-emerald-600",
    "teal": "bg-teal-600",
    "cyan": "bg-cyan-600",
    "sky": "bg-sky-600",
    "blue": "bg-blue-600",
    "indigo": "bg-indigo-600",
    "violet": "bg-violet-600",
    "purple": "bg-purple-600",
    "fuchsia": "bg-fuchsia-600",
    "pink": "bg-pink-600",
    "rose": "bg-rose-600",
    "slate": "bg-slate-600",
    "gray": "bg-gray-600",
    "zinc": "bg-zinc-600",
    "neutral": "bg-neutral-600",
    "stone": "bg-stone-600",
    "taupe": "bg-taupe-600",
    "mauve": "bg-mauve-600",
    "mist": "bg-mist-600",
    "olive": "bg-olive-600"
};

export const textColorMap: Record<string, string> = {
    "red": "text-red-600",
    "orange": "text-orange-600",
    "amber": "text-amber-600",
    "yellow": "text-yellow-600",
    "lime": "text-lime-600",
    "green": "text-green-600",
    "emerald": "text-emerald-600",
    "teal": "text-teal-600",
    "cyan": "text-cyan-600",
    "sky": "text-sky-600",
    "blue": "text-blue-600",
    "indigo": "text-indigo-600",
    "violet": "text-violet-600",
    "purple": "text-purple-600",
    "fuchsia": "text-fuchsia-600",
    "pink": "text-pink-600",
    "rose": "text-rose-600",
    "slate": "text-slate-600",
    "gray": "text-gray-600",
    "zinc": "text-zinc-600",
    "neutral": "text-neutral-600",
    "stone": "text-stone-600",
    "taupe": "text-taupe-600",
    "mauve": "text-mauve-600",
    "mist": "text-mist-600",
    "olive": "text-olive-600"
};

export const textColorMapTranslation: Record<string, string> = {
    "red": "rosso",
    "orange": "arancione",
    "amber": "ambra",
    "yellow": "giallo",
    "lime": "lime",
    "green": "verde",
    "emerald": "smeraldo",
    "teal": "verde petrolio",
    "cyan": "ciano",
    "sky": "azzurro cielo",
    "blue": "blu",
    "indigo": "indaco",
    "violet": "viola",
    "purple": "porpora",
    "fuchsia": "fucsia",
    "pink": "rosa",
    "rose": "rosa antico",
    "slate": "ardesia",
    "gray": "grigio",
    "zinc": "zinco",
    "neutral": "neutro",
    "stone": "pietra",
    "taupe": "tortora",
    "mauve": "malva",
    "mist": "nebbia",
    "olive": "verde oliva"
};